import {default as sanitizeHTML} from "sanitize-html";

export function sanitizeForReact(dirty: string): string {
    return sanitizeHTML(dirty, {
        allowedTags: [],
        disallowedTagsMode: 'recursiveEscape'
    })
}
